/**
*  Block Edit
*
*
* @returns {Array} Block group.
*/
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
const Edit = () => {
	const TEMPLATE = [ [ 'core/group',
	{
		className: 'page__content-text text',
	}, ] ];	
	return (
		<InnerBlocks
			template={ TEMPLATE }
		/> 
	)
};
export default Edit;
 